// extracted by mini-css-extract-plugin
export default {"Virtual":"virtual_Virtual__1knM6","left":"virtual_left__MahCC","wrapper":"virtual_wrapper__hpCxZ"};